var canvasCreator = function (width, height) {
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
};
export function getCanvasCreator() {
    return canvasCreator;
}
export function setCanvasCreator(creator) {
    canvasCreator = creator;
}
